import { render, staticRenderFns } from "./commonIconClear.vue?vue&type=template&id=08b05398&scoped=true"
import script from "./commonIconClear.vue?vue&type=script&lang=js"
export * from "./commonIconClear.vue?vue&type=script&lang=js"
import style0 from "./commonIconClear.vue?vue&type=style&index=0&id=08b05398&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b05398",
  null
  
)

export default component.exports